import { render, staticRenderFns } from "./InstructorForm.vue?vue&type=template&id=09e0dc7e&scoped=true&"
import script from "./InstructorForm.vue?vue&type=script&lang=js&"
export * from "./InstructorForm.vue?vue&type=script&lang=js&"
import style0 from "./InstructorForm.vue?vue&type=style&index=0&id=09e0dc7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0dc7e",
  null
  
)

export default component.exports